<template>
  <div class="error-page container">
    <div class="error-page__content">
      <breadcrumbs
        v-if="breadcrumbs"
        :items="breadcrumbs"
        class="error-page__breadcrumbs" />
      <h1 class="error-page__title">
        Oops! Something’s missing<br>
        Page not found
      </h1>
      <img
        src="/images/404.svg"
        alt=""
        class="error-page__img">
      <router-link
        :to="{ name: 'root' }"
        class="error-page__link button button-main error-page__button">
        Go to Main Page
      </router-link>
    </div>
  </div>
</template>

<script>
import GameModel from 'Models/GameModel';
import Breadcrumbs from 'Components/ui/Breadcrumbs/Breadcrumbs.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Error404',

  components: {
    Breadcrumbs,
  },

  data() {
    return {
      GameModel,
    };
  },

  computed: {
    ...mapState(['activeRegion']),

    breadcrumbs() {
      return [
        {
          title: 'SkyCoach',
          href: '/',
        },
        {
          title: '404 Page',
          href: '/404',
        },
      ];
    },
  },

  watch: {
    $route: {
      handler() {
        this.mutateHttpErrorCode(null);
      },
    },

    activeRegion() {
      if (this.$route.meta?.mayVaryByRegion) {
        this.mutateHttpErrorCode(null);
      }
    },
  },

  methods: {
    ...mapMutations(['mutateHttpErrorCode']),
  },
};
</script>

<style lang="scss" scoped>
  .error-page {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .error-page__content {
    margin: 24px 0 0;
    display: grid;
    grid-gap: 24px;
    grid-template-areas:
        "breadcrumbs"
        "title"
        "error"
        "links";
  }

  .error-page__breadcrumbs {
    grid-area: breadcrumbs;
  }

  .error-page__title {
    grid-area: title;
    font-weight: 500;
    font-size: 21px;
    color: $color--basic-white;
    line-height: 1.2;
  }

  .error-page__img {
    grid-area: error;
    width: 100%;
    height: auto;
  }

  .error-page__button {
    padding: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: none;
    font-size: 13px;
  }

  .error-page__link {
    grid-area: links;
  }

  @media screen and (min-width: 768px) {
    .error-page__content {
      grid-template-columns: 325px 1fr;
      grid-gap: 24px 30px;
      align-items: center;
      justify-items: start;
      grid-template-areas:
        "breadcrumbs error"
        "title error"
        "links error";
    }

    .error-page__img {
      margin: auto 0 0;
    }

    .error-page__title {
      font-size: 25px;
    }

    .error-page__button {
      padding: 14px;
      font-size: 15px;
      line-height: 20px;
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .error-page__content {
      margin: 200px 0;
    }
  }

  @media screen and #{$screen-more-or-1366} {
    .error-page__content {
      grid-template-columns: 36% 1fr;
      grid-column-gap: 50px;
    }

    .error-page__title {
      font-size: 35px;
    }
  }
</style>
